import React from 'react';
import { Target, Eye, Briefcase } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../utils/mockData';

const About = () => {
  const { language } = useLanguage();
  const t = translations[language];

  return (
    <section id="about" className="py-20 bg-gradient-to-b from-white to-stone-50">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4" style={{ fontFamily: 'Arial, sans-serif' }}>
              {t.about.title}
            </h2>
            <div className="w-24 h-1 bg-yellow-600 mx-auto"></div>
          </div>

          {/* Content Grid */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* Mission */}
            <div className="group bg-white p-8 rounded-xl border border-gray-200 hover:border-yellow-600 hover:shadow-xl transition-all duration-300">
              <div className="bg-yellow-50 w-16 h-16 rounded-full flex items-center justify-center mb-6 group-hover:bg-yellow-600 transition-colors duration-300">
                <Target className="h-8 w-8 text-yellow-600 group-hover:text-black transition-colors duration-300" />
              </div>
              <h3 className="text-2xl font-bold text-slate-900 mb-4" style={{ fontFamily: 'Arial, sans-serif' }}>
                {t.about.mission}
              </h3>
              <p className="text-slate-600 leading-relaxed">
                {t.about.missionText}
              </p>
            </div>

            {/* Vision */}
            <div className="group bg-white p-8 rounded-xl border border-gray-200 hover:border-yellow-600 hover:shadow-xl transition-all duration-300">
              <div className="bg-yellow-50 w-16 h-16 rounded-full flex items-center justify-center mb-6 group-hover:bg-yellow-600 transition-colors duration-300">
                <Eye className="h-8 w-8 text-yellow-600 group-hover:text-black transition-colors duration-300" />
              </div>
              <h3 className="text-2xl font-bold text-slate-900 mb-4" style={{ fontFamily: 'Arial, sans-serif' }}>
                {t.about.vision}
              </h3>
              <p className="text-slate-600 leading-relaxed">
                {t.about.visionText}
              </p>
            </div>

            {/* Professional Approach */}
            <div className="group bg-white p-8 rounded-xl border border-gray-200 hover:border-yellow-600 hover:shadow-xl transition-all duration-300">
              <div className="bg-yellow-50 w-16 h-16 rounded-full flex items-center justify-center mb-6 group-hover:bg-yellow-600 transition-colors duration-300">
                <Briefcase className="h-8 w-8 text-yellow-600 group-hover:text-black transition-colors duration-300" />
              </div>
              <h3 className="text-2xl font-bold text-slate-900 mb-4" style={{ fontFamily: 'Arial, sans-serif' }}>
                {t.about.approach}
              </h3>
              <p className="text-slate-600 leading-relaxed">
                {t.about.approachText}
              </p>
            </div>
          </div>

          {/* Video Section with Overlay Text */}
          <div className="mt-16 relative rounded-2xl overflow-hidden shadow-2xl h-96">
            <video 
              autoPlay 
              loop 
              muted 
              playsInline
              className="absolute inset-0 w-full h-full object-cover"
              style={{ filter: 'brightness(0.7)' }}
            >
              <source src="https://customer-assets.emergentagent.com/job_gr8-cabos/artifacts/zp3abo1l_CC%20add%20Richard%20Tezal%281%29.mp4#t=0,20" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
            <div className="absolute inset-0 bg-gradient-to-r from-slate-900/80 to-transparent flex items-center">
              <div className="px-12">
                <p className="text-white text-2xl md:text-3xl font-bold max-w-xl" style={{ fontFamily: 'Arial, sans-serif' }}>
                  {language === 'en' 
                    ? 'Excellence in every detail, quality in every project' 
                    : 'Excelencia en cada detalle, calidad en cada proyecto'}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
